// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"db5a9769","596":"31afcb31","782":"7ea83657"}[chunkId] + ".chunk.css";
};